let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ahwzx")).then(() => parcelRequire('4FORW'));